import { render, staticRenderFns } from "./Participaciones.vue?vue&type=template&id=af7b332c&scoped=true&"
import script from "./Participaciones.vue?vue&type=script&lang=js&"
export * from "./Participaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7b332c",
  null
  
)

export default component.exports